import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { StorageService } from '../storage/storage.service';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  darkMode = false;

  constructor(
    private plt: Platform,
    private device: Device,
    private storage: StorageService,
    private authentication: AuthenticationService
  ) { }

  initTheme() {
    this.plt.ready().then(() => {
      this.storage.get("dark_mode").then(theme => { // Also add column to AppUser for prefer dark. If theme is not in storage, query for it
        if(theme) {
          this.setAppTheme(theme);
        } else {
          this.storage.get("DATABASE").then(databaseName => {
            if(databaseName) {
              this.authentication.checkForUser().subscribe(user => {
                var platform = this.device.platform || "web";
                this.authentication.generateDeviceId(platform, user.id).then(id => {
                  this.authentication.checkForDevice(id, user.id).subscribe((device) => {
                    if(device) {
                      this.setAppTheme(device.dark_mode);
                    }
                  });
                });
              });
            } else {
              const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");
              this.setAppTheme(prefersDark.matches);
            }
          });
        }
      });
    });
  }

  toggleAppTheme() {
    this.darkMode = !this.darkMode;
    this.setAppTheme(this.darkMode);
  }

  setAppTheme(dark) {
    this.darkMode = dark;
    this.darkMode ? document.body.classList.add("dark") : document.body.classList.remove("dark");

    this.storage.set("dark_mode", this.darkMode); // Update storage with the user's preference
  }
}
